import React from "react";
import { LegalShell, LegalH5, LegalH5First, LegalP } from "../components/LegalShell";

const P = (key) => <LegalP key={key} i18nKey={key} />;
const NS = "legal.privacy_page";

export default function Privacy() {
  return (
    <LegalShell
      titleKey={`${NS}.title`}
      versionKey={`${NS}.version`}
      dateKey={`${NS}.date`}
      testId="privacy-page"
    >
      <LegalH5First i18nKey={`${NS}.s1_title`} />
      {P(`${NS}.s1_p1`)}
      {P(`${NS}.s1_p2`)}

      <LegalH5 i18nKey={`${NS}.s2_title`} />
      {P(`${NS}.s2_p1`)}
      {P(`${NS}.s2_p2`)}
      {P(`${NS}.s2_p3`)}
      {P(`${NS}.s2_p4`)}

      <LegalH5 i18nKey={`${NS}.s3_title`} />
      {P(`${NS}.s3_p1`)}
      {P(`${NS}.s3_p2`)}
      {P(`${NS}.s3_p3`)}

      <LegalH5 i18nKey={`${NS}.s4_title`} />
      {P(`${NS}.s4_p1`)}
      {P(`${NS}.s4_p2`)}
      {P(`${NS}.s4_p3`)}

      <LegalH5 i18nKey={`${NS}.s5_title`} />
      {P(`${NS}.s5_p1`)}
      {P(`${NS}.s5_p2`)}

      <LegalH5 i18nKey={`${NS}.s6_title`} />
      {P(`${NS}.s6_p1`)}
      {P(`${NS}.s6_p2`)}

      <LegalH5 i18nKey={`${NS}.s7_title`} />
      {P(`${NS}.s7_p1`)}

      <LegalH5 i18nKey={`${NS}.s8_title`} />
      {P(`${NS}.s8_p1`)}
    </LegalShell>
  );
}
